import React from "react";

interface IInitialsBadgeProps {
  firstName?: string;
  lastName?: string;
  userId?: number | null;
}

export const InitialsBadge: React.FC<IInitialsBadgeProps> = ({
  firstName,
  lastName,
  userId,
}) => {
  if (userId == null) return <span className="text-gray-400">—</span>;
  const initials = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`;
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return (
    <span
      title={fullName || `#${userId}`}
      className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary-color text-white text-xs font-medium"
    >
      {initials || `#${userId}`}
    </span>
  );
};
